import { ca } from '@cian/analytics';

export const trackRealtorCatalogLinkClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'ListingAgents',
  });
};
